import Vue from "vue";
import Vuex from "vuex";
import { auth } from "@/store/modules/auth";
import { accounts } from "@/store/modules/accounts";
import { categories } from "@/store/modules/categories";
import { transactions } from "@/store/modules/transactions";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    message: null,
    messageShown: false,
  },
  mutations: {
    SET_MESSAGE(state, message) {
      state.message = message;
    },
    SET_MESSAGE_SHOWN(state, messageShown) {
      state.messageShown = messageShown;
    },
  },
  actions: {
    showMessage({ commit }, message) {
      commit("SET_MESSAGE", message);
      commit("SET_MESSAGE_SHOWN", true);
    },
  },
  modules: {
    auth,
    accounts,
    categories,
    transactions,
  },
});
